require("!!C:\\Users\\Tyler\\Desktop\\projects\\formatically_node\\packages\\citation-tool\\node_modules\\script-loader\\addScript.js")(require("!!C:\\Users\\Tyler\\Desktop\\projects\\formatically_node\\packages\\citation-tool\\node_modules\\raw-loader\\index.js!C:\\Users\\Tyler\\Desktop\\projects\\formatically_node\\packages\\citation-tool\\static\\citeproc.js"))


//////////////////
// WEBPACK FOOTER
// ./node_modules/script-loader!./static/citeproc.js
// module id = G0n4
// module chunks = 1